import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { CTAButton } from "@/components/ui/cta-button";
import { Check } from "lucide-react";

export const PricingSection = () => {
  return (
    <section id="pricing" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/3 to-transparent" />
      </div>

      <div className="section-container relative z-10">
        <div className="content-medium space-y-12">
          <div className="text-center space-y-4 animate-fade-in-up">
            <h2 className="font-display font-medium leading-tight">
              Simple pricing. <span className="text-primary">No surprises</span>.
            </h2>
            <p className="text-lg text-muted-foreground">
              AI-powered MVPs in 7 days. Complete ownership. Ready to launch.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-stretch justify-center gap-8 max-w-6xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <Card className="border-border/50 relative overflow-hidden w-full max-w-[450px] flex flex-col">
              <div className="absolute top-4 right-4 bg-primary text-primary-foreground px-3 py-1 rounded text-sm font-medium">
                Limited Time
              </div>
              <CardHeader>
                <CardTitle className="text-3xl font-heading">1 Week MVP</CardTitle>
                <CardDescription className="text-base">Our flagship package — ship in 7 days.</CardDescription>
              </CardHeader>
              <CardContent className="space-y-6 flex-1 flex flex-col">
                <div>
                  <div className="space-y-1 mb-2">
                    <div className="text-sm text-muted-foreground line-through">$1,999</div>
                    <div className="text-4xl font-heading">$999</div>
                    <div className="text-sm text-primary font-medium">50% OFF Limited Time</div>
                  </div>
                  <div className="text-sm text-muted-foreground space-y-1 mt-3">
                    <div><strong>Timeline:</strong> 7 days</div>
                    <div><strong>Seats:</strong> 4 per week</div>
                  </div>
                </div>

                <div className="flex-1">
                  <h4 className="font-medium mb-3">What's Included:</h4>
                  <ul className="space-y-2">
                    {[
                      "Full design & development",
                      "Auth, payments, admin dashboard",
                      "AI integrations",
                      "Production deployment",
                      "30 days support"
                    ].map((feature, featureIdx) => (
                      <li key={featureIdx} className="flex gap-2">
                        <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-muted-foreground">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Button className="w-full" size="lg" asChild>
                  <a href="/package-details" title="View detailed information about our One Week MVP Build package">
                    View Package Details
                  </a>
                </Button>
              </CardContent>
            </Card>

            <Card className="border-border/50 relative overflow-hidden w-full max-w-[450px] flex flex-col">
              <CardHeader>
                <div className="inline-block mb-2 px-3 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary">
                  Custom Projects
                </div>
                <CardTitle className="text-3xl font-heading">Need Something Bigger?</CardTitle>
                <CardDescription className="text-base">Custom development projects tailored to your specific requirements. Multi-platform apps, complex integrations, and enterprise-level features.</CardDescription>
              </CardHeader>
              <CardContent className="space-y-6 flex-1 flex flex-col">
                <div className="flex-1">
                  <h4 className="font-medium mb-3">Best For:</h4>
                  <ul className="space-y-2">
                    {[
                      "Multi-platform apps (web + mobile)",
                      "Complex integrations & APIs",
                      "Enterprise-level features",
                      "Extended timelines (2-4 weeks)",
                      "White-label solutions",
                      "Custom scope & features"
                    ].map((feature, idx) => (
                      <li key={idx} className="flex gap-2">
                        <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-muted-foreground">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Button className="w-full" size="lg" variant="outline" asChild>
                  <a href="/calculator" title="Use our MVP cost calculator to estimate your custom project cost">
                    Calculate My Cost
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <p className="text-sm text-muted-foreground">
              Only 4 spots available per week. Quality over quantity.
            </p>
          </div>
        </div>
      </div>

    </section>
  );
};
